module.exports = __webpack_public_path__ + "media/images/program/app_tabs-5b0a3ca01fbf148c9b41af7b453df2e7a893dd43163fa33ffc4834fd5a79c6dc.png";